import React from 'react';
import { Link } from 'react-router-dom';
import './Styles/Notfound.css';

const NotFound = () => {
  return (
    <main className="not-found">
      <div className="not-found__content">
        <img
          className="not-found__image"
          src="/assets/img/illustrations/error-404.png"
          alt="404 page not found"
        />
        <h1 className="not-found__title">404</h1>
        <p className="not-found__message">Page not found</p>
        <Link className="not-found__home" to="/">Back to sign in</Link>
      </div>
    </main>
  );
};

export default NotFound;